<script>
    import appConfig from '@src/app.config'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'

    import * as axios from "axios";

    const PUBLISHERS_API_URL = process.env.VUE_APP_API_URL + 'publishers/';
    const USERS_API_URL = process.env.VUE_APP_API_URL + 'users/';

    /**
     * Advanced table component
     */
    export default {
        page: {
            title: 'My Sites',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: { Layout, PageHeader },
        data() {
            return {
                tableData: [],
                title: 'My sites',
                items: [
                    {
                        text: 'Unblockia',
                        href: '/',
                    },
                    {
                        text: 'My Sites',
                        href: true,
                    },
                ],
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: 'domain',
                sortDesc: false,
                rows: '',
                fields: [
                    { key: 'domain', sortable: true },
                    { key: 'createdAt', sortable: true },
                    { key: 'isActive', sortable: true },
                    { key: 'validation', label: '' , tdClass: 'button-width'},
                ],
            }
        },
        computed: {
            /**
             * Total no. of records
             */
            currentUserId: () => {
            return  JSON.parse(localStorage["auth.currentUser"]).id
            }

        },
        async mounted() {
            await this.fetchPublisherSites();
            // Set the initial number of items
            this.totalRows = this.items.length
            this.rows = this.tableData.length
            
        },
        methods: {
            /**
             * Search the table data with search input
             */
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.rows = filteredItems.length;
                this.currentPage = 1
            },
            async fetchPublisherSites() {
                //获取user的publisherId，赋值给currentPublisherId！！！！！！
                const fetchSitesResponse = await axios.get(`${USERS_API_URL}${this.currentUserId}/sites`)
                this.tableData = fetchSitesResponse.data.map(item => ({
                    ...item,
                    createdAt: new Date(item.created_at).toISOString().slice(0, 10),
                    isActive: item.isActive ? '✔' : '❌ ',
                }));
            },
            createSite() {
                this.$router.push(`/users/${this.currentUserId}/sites/create`)
            },
            handleValidate(siteId) {
                this.$router.push( `/users/${this.currentUserId}/sites/${siteId}/validate` )
            }
        },
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title">Site List</h4>
                        <b-button
                                variant="primary"
                                class="width-xs create-button"
                                @click="createSite"
                        > Create a site (will be hidden)
                        </b-button>
                        <p class="text-muted font-13 mb-4"></p>
                        <div class="row mb-md-2">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    ref="table"
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    @filtered="onFiltered"
                            >
                            <template #cell(validation)="data" class="">
                                <b-button  variant="primary" class="btn-xs" v-if="data.item.status<3" @click="handleValidate(data.item.id)">Validate</b-button>
                                <span class="whitelisting" v-if="data.item.status===3">Whitelisting</span>
                                <span class="is-active" v-if="data.item.status>3">Active</span>
                            </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="rows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style lang="scss">
.button-width {
    width:15%
}
.whitelisting{
    color:#6c757d
}
.is-active{
    color:#2AA800;
}
</style>
